import { render, staticRenderFns } from "./GlobalDashboard.vue?vue&type=template&id=770c772a&scoped=true"
import script from "./GlobalDashboard.vue?vue&type=script&lang=js"
export * from "./GlobalDashboard.vue?vue&type=script&lang=js"
import style0 from "./GlobalDashboard.vue?vue&type=style&index=0&id=770c772a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770c772a",
  null
  
)

export default component.exports